export default __webpack_public_path__ + "static/media/Loading Recipe.4490fca8.png";